export const WHITE = '#fff'
export const WHITE_MUTED = '#ced4da'
export const GREY = '#2c3e50'
export const BLACK = '#1a222a'
export const LIGHT_GREY = '#a8b3bd'
export const PURPLE = '#7768AE'
export const BLUE = '#4D9DE0'
export const GREEN = '#3BB273'
export const YELLOW = '#E1BC29'
export const RED = '#E15554'

export const BLUE_SOFT = '#AFCBFA'
export const YELLOW_SOFT = '#FEF475'
export const GREEN_SOFT = '#C6F78B'
export const ORANGE_SOFT = '#FFD27A'
export const RED_SOFT = '#FF8A7D'

export const workflowPathColorsList = [BLUE, GREEN, YELLOW, RED, PURPLE, GREY, WHITE_MUTED]
export const workflowShapeColorsList = [BLUE, GREEN, YELLOW, RED, PURPLE, GREY]
export const workflowNoteColorsList = [GREEN_SOFT, BLUE_SOFT, YELLOW_SOFT, ORANGE_SOFT, RED_SOFT]
